import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data);
        if (data.is_admin) {
          navigate("/dashboard", { replace: true, state: { user: data } });
        } else {
          setError("Your account doesn't have admin access.");
          setTimeout(() => navigate("/", { replace: true }), 2500);
        }
      } catch (e) {
        // Surface the real error so we can debug
        const status = e?.response?.status;
        const detail = e?.response?.data?.detail || e?.message || "unknown";
        // eslint-disable-next-line no-console
        console.error("[AuthCallback] /auth/session failed", { status, detail, error: e });
        setError(`Sign-in failed (${status || "network"}): ${detail}`);
        setTimeout(() => navigate("/login", { replace: true }), 5000);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0B1020] px-6" data-testid="auth-callback">
      <div className="text-center">
        <div className="mx-auto h-10 w-10 animate-pulse rounded-full gradient-bg" />
        <p className="mt-6 text-sm text-white/70">{error || "Signing you in…"}</p>
      </div>
    </div>
  );
}
